{
  "version": 1,
  "asset_id": "81de7518-686e-43fb-bfc0-1c51b8630244",
  "project_id": "f4a4cb9e-10ac-4832-a8e3-d05c1765811e",
  "url": "/__l5e/assets-v1/81de7518-686e-43fb-bfc0-1c51b8630244/jaik-construction-montage-poster.jpg",
  "r2_key": "a/v1/f4a4cb9e-10ac-4832-a8e3-d05c1765811e/81de7518-686e-43fb-bfc0-1c51b8630244/jaik-construction-montage-poster.jpg",
  "original_filename": "jaik-construction-montage-poster.jpg",
  "size": 190692,
  "content_type": "image/jpeg",
  "created_at": "2026-09-09T05:28:59Z"
}
